import { PageBody } from '@pypestream/design-system';
import { CSSProperties, FC } from 'react';
import { Outlet } from 'react-router';

import { Loader } from '../../components';
import { useLoadingState } from '../../hooks';
import { ProjectAreaSidenav } from './project-area-sidenav';

// Centered loader that reserves the top-nav height, so the loader (and the
// content that replaces it) don't jump down once the nav finishes rendering.
const loaderContainerStyle: CSSProperties = {
  position: 'absolute',
  left: 0,
  top: 64,
  width: '100%',
  height: 'calc(100% - 64px)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

// Layout for the Project Settings area: a left side-nav (filled menu variant)
// driving the nested section routes rendered via <Outlet />. Rendered as a
// fragment so the sidenav + body slot directly into the <Page> from Root,
// matching the design-system "WithSidenav" pattern.
export const ProjectSettings: FC = () => {
  const loading = useLoadingState();

  // Hold the whole layout (side-nav + body) behind a loader until the app data
  // the nav depends on is ready. Otherwise the content renders first and jumps
  // down once the top nav mounts.
  if (loading) {
    return (
      <div style={loaderContainerStyle}>
        <Loader relative />
      </div>
    );
  }

  return (
    <>
      <ProjectAreaSidenav />
      <PageBody background="none">
        <Outlet />
      </PageBody>
    </>
  );
};
